export const ExpenseDetailsMutations = {
  SetLoading: 'SetLoading',
  RetrieveExpenseSuccess: 'RetrieveExpenseSuccess',
  ResetExpenseState: 'ResetExpenseState',
  SetAttachmentsLoading: 'SetLoading',
  RetrieveAttachmentsSuccess: 'RetrieveAttachmentsSuccess',
  RetrieveHistorySuccess: 'RetrieveHistorySuccess'
};

export const ExpenseDetailsActions = {
  RetrieveExpense: 'RetrieveExpense',
  SaveExpense: 'SaveExpense',
  ReopenExpense: 'ReopenExpense',
  ExpenseApproverAction: 'ExpenseApproverAction',
  ResetCurrentExpense: 'ResetCurrentExpense',
  RetrieveExpenseAttachments: 'RetrieveExpenseAttachments',
  RetrieveExpenseHistory: 'ExpenseDetailsActions.RetrieveExpenseHistory'
};

export const ExpenseDetailsGetters = {
  CurrentExpense: 'CurrentExpense',
  IsLoading: 'expenseDetailsIsLoading'
};
